// Standard library imports
import React, { useState, useEffect } from 'react';

// External library imports
import { toast } from 'react-toastify';
import { get as lodashGet } from 'lodash';

// Internal module imports
import Typography from '../../../../components/Typography/Typography';
import { RootBiddingService } from '../../../../services/BiddingService/Root/BiddingService';
import { useLoader, useUserRole } from '../../../../hooks';
import bidClasses from '../Bidding.module.css';
import { getTotalHoursForDay } from '../../../../utils/dateHelper';
import { getColumnWithSlotSize } from '../../../../utils/biddingHelper';
import { AdminBiddingService } from '../../../../services/BiddingService/Admin/BiddingService';

export const OverallCapacity = ({ params }) => {
    const { isRootUser } = useUserRole();
    const service = isRootUser ? RootBiddingService : AdminBiddingService;
    const [startLoader, stopLoader] = useLoader();
    const [data, setData] = useState({
        approvedCapacity: 0,
        energinetCapacity: 0,
        hourlyCapacity: [],
        energinetHourlyCapacity: [],
    });

    const totalHours = getTotalHoursForDay(params.bidDate);
    const slots = Array.from({ length: totalHours }, (__, i) => i);
    const columns = getColumnWithSlotSize(slots, 8);

    useEffect(() => {
        if (Object.keys(params).length) getData();
    }, [params]);

    const getData = () => {
        service.GetOverallCapacity(params, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => {
        setData(data.data);
    };

    const handleError = (err) => {
        toast.error(lodashGet(err, ['response', 'data', 'message']));
    };

    return (
        <div className={`${bidClasses.InfoModalContainer}`}>
            <div>
                <div className={bidClasses.Flex} style={{ justifyContent: 'space-between' }}>
                    <div className={bidClasses.InfoModalHeading}>
                        <Typography content={`Total Approved Capacity : ${lodashGet(data, ['approvedCapacity'], 0).toFixed(2)}`} size={14} />
                    </div>
                    <div className={bidClasses.InfoModalHeading}>
                        <Typography content={`Total Energinet Capacity : ${lodashGet(data, ['energinetCapacity'], 0).toFixed(2)}`} size={14} />
                    </div>
                </div>

                <div>
                    <div className={bidClasses.InfoModalHeading}>
                        <Typography content={'Instance Capacity'} size={14} />
                    </div>
                    <div className={bidClasses.TableContainer}>
                        {columns.map((column, colIndex) => (
                            <table key={colIndex}>
                                <tr>
                                    <th>Slot</th>
                                    <th>Hour</th>
                                    <th>Capacity</th>
                                </tr>
                                <tbody>
                                    {column.map((key) => (
                                        <tr>
                                            <td>{key + 1}</td>
                                            <td>
                                                {key}-{key + 1}
                                            </td>
                                            <td>{lodashGet(data, ['hourlyCapacity', key])}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ))}
                    </div>
                </div>

                <div>
                    <div className={bidClasses.InfoModalHeading}>
                        <Typography content={'Energinet Capacity'} size={14} />
                    </div>
                    <div className={bidClasses.TableContainer}>
                        {columns.map((column, colIndex) => (
                            <table key={colIndex}>
                                <tr>
                                    <th>Slot</th>
                                    <th>Hour</th>
                                    <th>Capacity</th>
                                </tr>
                                <tbody>
                                    {column.map((key) => (
                                        <tr>
                                            <td>{key + 1}</td>
                                            <td>
                                                {key}-{key + 1}
                                            </td>
                                            <td>{lodashGet(data, ['energinetHourlyCapacity', key])}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
